import * as React from 'react';
import { SVGProps } from 'react';
import { withForgeIconProps } from './ForgeIconProps';
interface SVGRProps {
  title?: string;
  titleId?: string;
}

const SvgGraphLarge = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps): JSX.Element => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="fi_c_icon"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M22.5 1.5L13 12L9 8L1 16.5M1 23H23M16 1H23V8"
      stroke={props.color}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

SvgGraphLarge.displayName = 'SvgGraphLarge';
const GraphLarge = withForgeIconProps(SvgGraphLarge, {
  name: 'Graph',
  usage:
    'Use to indicate a graph or flowsheet, or the ability to switch to a graph or flowsheet view.',
  related: 'table, list, chart, flowchart, data',
  isLabelRequired: true,
  isNeutralInteractive: false,
  size: 'large',
});
export default GraphLarge;
